import { render, staticRenderFns } from "./counterpartiesList.vue?vue&type=template&id=35bfde49&scoped=true"
import script from "./counterpartiesList.vue?vue&type=script&lang=js"
export * from "./counterpartiesList.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesList.vue?vue&type=style&index=0&id=35bfde49&prod&lang=scss&scoped=true"
import style1 from "./counterpartiesList.vue?vue&type=style&index=1&id=35bfde49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bfde49",
  null
  
)

export default component.exports